/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => {
  const isAuth = useSelector((state) => state.user.profile.user_isAuth);
  const role = useSelector((state) => state.user.profile.role);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuth === false) {
          return <Component {...props} />;
        } else {
          if (role?.includes("KASIR RESTO")) {
            return <Redirect to="/sales/cashier" />;
          } else if (role === "WAITRESS") {
            return <Redirect to="/sales/order" />;
          } else if (role === "WAITRESS FAST FOOD") {
            return <Redirect to="/sales/fast-food" />;
          } else {
            return <Redirect to="/dashboard" />;
          }
        }
      }}
    />
  );
};

export default PublicRoute;
